var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilmReel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.059,
    x2: 396.345,
    xlinkHref: "#lg1",
    y1: 468.526,
    y2: 356.383
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.849,
    x2: 347.134,
    y1: 468.802,
    y2: 295.23
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#5b2d81",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7057,
    stopColor: "#4b2d6b",
    stopOpacity: 0.706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452d63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.357,
    x2: 289.062,
    xlinkHref: "#lg1",
    y1: 149.357,
    y2: 289.062
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    stopColor: "#632d8c",
    stopOpacity: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5953,
    stopColor: "#5b2d81",
    stopOpacity: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8785,
    stopColor: "#4d2d6e",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452d63"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 255,
    cy: 255,
    gradientUnits: "userSpaceOnUse",
    r: 253.931,
    xlinkHref: "#lg2"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 255,
    cy: 255,
    gradientUnits: "userSpaceOnUse",
    r: 264.427,
    xlinkHref: "#lg2"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 255,
    cy: 255,
    gradientUnits: "userSpaceOnUse",
    r: 234.549,
    xlinkHref: "#lg2"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 255,
    cy: 255,
    gradientUnits: "userSpaceOnUse",
    r: 205.075,
    xlinkHref: "#lg2"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.27,
    x2: -12.896,
    xlinkHref: "#lg3",
    y1: 440.27,
    y2: -12.896
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.388,
    x2: 388.719,
    xlinkHref: "#lg3",
    y1: 148.388,
    y2: 388.719
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -105.625 255)",
    gradientUnits: "userSpaceOnUse",
    x1: 292.534,
    x2: 248.706,
    xlinkHref: "#lg4",
    y1: 249.663,
    y2: 205.834
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -105.625 255)",
    gradientUnits: "userSpaceOnUse",
    x1: 292.534,
    x2: 248.706,
    xlinkHref: "#lg4",
    y1: 335.406,
    y2: 291.577
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 255 -105.625)",
    gradientUnits: "userSpaceOnUse",
    x1: 292.534,
    x2: 248.706,
    xlinkHref: "#lg4",
    y1: 249.663,
    y2: 205.834
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 255 -105.625)",
    gradientUnits: "userSpaceOnUse",
    x1: 292.534,
    x2: 248.706,
    xlinkHref: "#lg4",
    y1: 335.406,
    y2: 291.577
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.375,
    x2: 290.904,
    xlinkHref: "#lg3",
    y1: 70.641,
    y2: 139.779
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.375,
    x2: 290.904,
    xlinkHref: "#lg3",
    y1: 378.014,
    y2: 447.153
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.679,
    x2: 422.216,
    xlinkHref: "#lg3",
    y1: 144.46,
    y2: 213.606
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.064,
    x2: 159.6,
    xlinkHref: "#lg3",
    y1: 304.192,
    y2: 373.338
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.062,
    x2: 159.609,
    xlinkHref: "#lg3",
    y1: 144.457,
    y2: 213.614
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.676,
    x2: 422.225,
    xlinkHref: "#lg3",
    y1: 304.183,
    y2: 373.343
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.159 383.258v-132.901h-31.89v137.672c0 64.01 51.89 115.9 115.9 115.9h10.886c8.806 0 15.945-7.139 15.945-15.945 0-8.806-7.139-15.945-15.945-15.945h-6.115c-49.032-.001-88.781-39.749-88.781-88.781z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.159 383.258v-132.901h-31.89v137.672c0 64.01 51.89 115.9 115.9 115.9h10.886c8.806 0 15.945-7.139 15.945-15.945 0-8.806-7.139-15.945-15.945-15.945h-6.115c-49.032-.001-88.781-39.749-88.781-88.781z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_3_)",
    r: 183.635
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_4_)",
    r: 168.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_5_)",
    r: 153.686
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_6_)",
    r: 136.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_7_)",
    r: 119.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 0c-140.83 0-255 114.17-255 255s114.17 255 255 255 255-114.17 255-255-114.17-255-255-255zm160.23 222.7c-26.27 15.98-60.51 7.64-76.49-18.63-15.97-26.27-7.63-60.51 18.64-76.49s60.52-7.64 76.49 18.63c15.98 26.27 7.63 60.51-18.64 76.49zm-160.23-65.72c-30.75 0-55.67-24.91-55.67-55.66s24.92-55.68 55.67-55.68 55.67 24.93 55.67 55.68-24.92 55.66-55.67 55.66zm-83.74 47.09c-15.98 26.27-50.22 34.61-76.49 18.63s-34.62-50.22-18.64-76.49 50.23-34.61 76.5-18.63 34.61 50.22 18.63 76.49zm-76.5 83.24c26.27-15.98 60.52-7.65 76.5 18.62 15.97 26.27 7.62 60.52-18.65 76.5s-60.51 7.63-76.48-18.64c-15.98-26.27-7.64-60.51 18.63-76.48zm160.24 65.71c30.75 0 55.67 24.93 55.67 55.67 0 30.75-24.92 55.67-55.67 55.67s-55.67-24.92-55.67-55.67c0-30.74 24.92-55.67 55.67-55.67zm83.75-47.09c15.97-26.27 50.22-34.6 76.49-18.62 26.27 15.97 34.61 50.21 18.64 76.48-15.98 26.27-50.22 34.62-76.49 18.64s-34.62-50.23-18.64-76.5z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 10.71c-134.91 0-244.29 109.38-244.29 244.29s109.38 244.29 244.29 244.29 244.29-109.38 244.29-244.29-109.38-244.29-244.29-244.29zm178.88 353.08c-15.98 26.27-50.22 34.62-76.49 18.64s-34.62-50.23-18.64-76.5c15.97-26.27 50.22-34.6 76.49-18.62 26.27 15.97 34.61 50.21 18.64 76.48zm-178.88 100.57c-30.75 0-55.67-24.92-55.67-55.67 0-30.74 24.92-55.67 55.67-55.67s55.67 24.93 55.67 55.67c0 30.75-24.92 55.67-55.67 55.67zm-178.87-100.57c-15.98-26.27-7.64-60.51 18.63-76.48 26.27-15.98 60.52-7.65 76.5 18.62 15.97 26.27 7.62 60.52-18.65 76.5s-60.51 7.63-76.48-18.64zm0-217.58c15.98-26.27 50.23-34.61 76.5-18.63s34.61 50.22 18.63 76.49-50.22 34.61-76.49 18.63-34.62-50.22-18.64-76.49zm178.87-100.57c30.75 0 55.67 24.93 55.67 55.68s-24.92 55.66-55.67 55.66-55.67-24.91-55.67-55.66 24.92-55.68 55.67-55.68zm178.87 100.57c15.98 26.27 7.63 60.51-18.64 76.49s-60.51 7.64-76.49-18.63c-15.97-26.27-7.63-60.51 18.64-76.49s60.52-7.64 76.49 18.63z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224.685,
    cy: 224.685,
    fill: "url(#SVGID_10_)",
    r: 19.628
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.315,
    cy: 285.315,
    fill: "url(#SVGID_11_)",
    r: 19.628
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 285.315,
    cy: 224.685,
    fill: "url(#SVGID_12_)",
    r: 19.628
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.685,
    cy: 285.315,
    fill: "url(#SVGID_13_)",
    r: 19.628
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 33.34c-37.54 0-67.97 30.42-67.97 67.97 0 37.54 30.43 67.98 67.97 67.98s67.97-30.44 67.97-67.98c0-37.55-30.43-67.97-67.97-67.97zm0 123.64c-30.75 0-55.67-24.91-55.67-55.66s24.92-55.68 55.67-55.68 55.67 24.93 55.67 55.68-24.92 55.66-55.67 55.66z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 340.71c-37.54 0-67.97 30.43-67.97 67.97 0 37.55 30.43 67.98 67.97 67.98s67.97-30.43 67.97-67.98c0-37.54-30.43-67.97-67.97-67.97zm0 123.65c-30.75 0-55.67-24.92-55.67-55.67 0-30.74 24.92-55.67 55.67-55.67s55.67 24.93 55.67 55.67c0 30.75-24.92 55.67-55.67 55.67z",
    fill: "url(#SVGID_15_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m444.39 139.81c-19.51-32.07-61.32-42.26-93.4-22.75-32.07 19.51-42.27 61.32-22.76 93.4s61.33 42.25 93.4 22.74c32.08-19.51 42.27-61.31 22.76-93.39zm-29.16 82.89c-26.27 15.98-60.51 7.64-76.49-18.63-15.97-26.27-7.63-60.51 18.64-76.49s60.52-7.64 76.49 18.63c15.98 26.27 7.63 60.51-18.64 76.49z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181.77 299.54c-19.51-32.08-61.32-42.26-93.39-22.75-32.08 19.51-42.28 61.32-22.77 93.4 19.51 32.07 61.33 42.25 93.41 22.74 32.07-19.51 42.26-61.31 22.75-93.39zm-29.16 82.89c-26.27 15.98-60.51 7.63-76.48-18.64-15.98-26.27-7.64-60.51 18.63-76.48 26.27-15.98 60.52-7.65 76.5 18.62 15.97 26.27 7.62 60.52-18.65 76.5z",
    fill: "url(#SVGID_17_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m159.01 117.06c-32.08-19.51-73.88-9.32-93.39 22.75-19.51 32.08-9.33 73.88 22.75 93.39s73.89 9.34 93.4-22.74 9.32-73.89-22.76-93.4zm12.25 87.01c-15.98 26.27-50.22 34.61-76.49 18.63s-34.62-50.22-18.64-76.49 50.23-34.61 76.5-18.63 34.61 50.22 18.63 76.49z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m421.63 276.79c-32.08-19.51-73.89-9.33-93.4 22.75s-9.32 73.88 22.76 93.39c32.07 19.51 73.89 9.33 93.4-22.74 19.51-32.08 9.31-73.89-22.76-93.4zm12.25 87c-15.98 26.27-50.22 34.62-76.49 18.64s-34.62-50.23-18.64-76.5c15.97-26.27 50.22-34.6 76.49-18.62 26.27 15.97 34.61 50.21 18.64 76.48z",
    fill: "url(#SVGID_19_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilmReel);
export default __webpack_public_path__ + "static/media/icon-film-reel.08c7228a1291c838ff1462647d70c9ac.svg";
export { ForwardRef as ReactComponent };